import { render, staticRenderFns } from "./CmgDeliveryAddressModal.vue?vue&type=template&id=a11c8b7a&scoped=true&lang=pug&"
import script from "./cmg-delivery-address-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-delivery-address-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgDeliveryAddressModal.vue?vue&type=style&index=0&id=a11c8b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11c8b7a",
  null
  
)

export default component.exports